import { render } from "./XssRiskPanel.vue?vue&type=template&id=f1e16bf8&scoped=true"
import script from "./XssRiskPanel.vue?vue&type=script&lang=js"
export * from "./XssRiskPanel.vue?vue&type=script&lang=js"

import "./XssRiskPanel.vue?vue&type=style&index=0&id=f1e16bf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1e16bf8"]])

export default __exports__